export var getRequestIds = function getRequestIds(_ref, hasSmsCode) {
  var externalId = _ref.externalId,
    verificationId = _ref.verificationId;
  if (!hasSmsCode) return {};
  return {
    externalId: externalId,
    verificationId: verificationId
  };
};